/**
 * Converts a SpEL string expression into a {@link index!DefaultRuleGroupType DefaultRuleGroupType}
 * or {@link index!DefaultRuleGroupTypeIC DefaultRuleGroupTypeIC}.
 *
 * @module parseSpEL
 */

export * from './parseSpEL';
